import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";

@autoinject
export class DocumentManagementService {
    constructor(private configService:ConfigService, private requestClientService: RequestClientService,) {
        
    }

    public async listRightshipInspectionDocumentAccess(rightshipInspectionId: number): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.documentManagementApiUrl + '/api/v1/InspectionAccess/ListAccess', null, {
                accessDetails: {
                    rightshipInspectionId : rightshipInspectionId,
                    emails : []
                }
        });
    };

    public async giveRightshipInspectionDocumentAccess(rightshipInspectionId: number, emails: string[]): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.documentManagementApiUrl + '/api/v1/InspectionAccess/GiveAccess', null, {
                accessDetails: {
                    rightshipInspectionId : rightshipInspectionId,
                    emails : emails
                }
        });
    };

    public async removeRightshipInspectionDocumentAccess(rightshipInspectionId: number, emails: string[]): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.documentManagementApiUrl + '/api/v1/InspectionAccess/RemoveAccess', null, {
                accessDetails: {
                    rightshipInspectionId : rightshipInspectionId,
                    emails : emails
                }
        });
    };

    /// This method will call the Qi api to send the email to the shared email addresses
    public async shareRightshipInspectionDocumentAccess(rightshipInspectionId: number, emails: string[], isResendEmail:boolean, emailContent: string): Promise<any> {
        return await this.requestClientService.post<any>(this.configService.config.urls.rightShipPlatformApiUrl + '/api/v1/RightShipInspection/ShareOutcomeReport', null, {
                rightShipInspectionId: rightshipInspectionId,
                emails : emails,
                isResendEmail: isResendEmail,
                emailContent: emailContent
        });
    };
}